export default {
    'onboarding': import('@/views/integrations/protokol/vpfr/Onboarding') 
}